import type { ClassGroupsAndSeriesInfo } from "@/models/interface/tutor";
import { ApiFactory, type ApiDataResponse } from "@/utils/api";

export class TutorService extends ApiFactory {
  constructor() {
    super('');
  }

  /**
   * 建立直播頻道
   * @param data 建立直播頻道所需的資料
   * @returns 直播頻道資訊
   */
  getClassGroupsAndSeriesInfo(): Promise<ApiDataResponse<ClassGroupsAndSeriesInfo>> {
    return super.get('GetClassGroupsAndSeriesInfo', null, {
      baseURL: import.meta.env.VITE_TUTOR_BASE_URL,
      headers: {
        unAuthorization: true
      }
    });
  }
}